import { render, staticRenderFns } from "./DashboardPeriodSelector.vue?vue&type=template&id=ad5ae534&scoped=true"
import script from "./DashboardPeriodSelector.vue?vue&type=script&lang=js"
export * from "./DashboardPeriodSelector.vue?vue&type=script&lang=js"
import style0 from "./DashboardPeriodSelector.vue?vue&type=style&index=0&id=ad5ae534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5ae534",
  null
  
)

export default component.exports